import React, { useState, useEffect } from "react";
import { api } from "../../../../lib/api";

export function FunnelPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/funnel-summary?since_days=30").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const c = data.counts;
  const stages = [
    { key: "cta_click", label: "CTA clicks", val: c.cta_click },
    { key: "register", label: "Registered", val: c.register },
    { key: "issue_complete", label: "Cards issued", val: c.issue_complete },
  ];
  const max = Math.max(1, ...stages.map((s) => s.val));
  return (
    <div className="bg-white border border-[#E5E0D8] rounded-2xl p-6" data-testid="funnel-panel">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">Growth funnel · last {data.window_days}d</p>
          <p className="serif text-2xl mt-1">
            {data.conversion_rate}% <span className="text-[#4A5C50] text-lg">CTA → card conversion</span>
          </p>
        </div>
        <div className="text-right">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">Total amount clicked</p>
          <p className="serif text-2xl mt-1 mono">${data.cta_total_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</p>
        </div>
      </div>
      <div className="mt-6 space-y-3">
        {stages.map((s) => (
          <div key={s.key} className="flex items-center gap-4" data-testid={`funnel-${s.key}`}>
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50] w-36">{s.label}</span>
            <div className="flex-1 h-8 bg-[#FBF9F6] border border-[#E5E0D8] rounded-lg overflow-hidden">
              <div
                className="h-full bg-[#184A30]/85 text-[#FBF9F6] flex items-center justify-end pr-3 text-xs mono"
                style={{ width: `${Math.max(5, (s.val / max) * 100)}%` }}
              >
                {s.val}
              </div>
            </div>
          </div>
        ))}
      </div>
      {data.recent_amounts && data.recent_amounts.length > 0 && (
        <div className="mt-6 pt-4 border-t border-[#E5E0D8]">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50] mb-2">Recently clicked amounts</p>
          <div className="flex flex-wrap gap-2">
            {data.recent_amounts.map((a, i) => (
              <span key={i} className="text-xs mono px-3 py-1 rounded-full bg-[#184A30]/10 text-[#184A30]" data-testid={`funnel-amt-${i}`}>${Number(a).toFixed(0)}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
